import { createAction } from 'typesafe-actions';

export const setSaveCardCheckbox = createAction(
  `ui-state/save-card-checkbox/SET`,
  (isChecked: boolean) => isChecked
)();
export const clearSaveCardCheckbox = createAction(
  `ui-state/save-card-checkbox/CLEAR`
)();

export const setCardInstallments = createAction(
  `ui-state/card-installments/SET`,
  (installments: number) => installments
)();
export const resetCardInstallments = createAction(
  `ui-state/card-installments/RESET`
)();
